const STORAGE_KEY = "ac_cart_added_feedback_v1";
let pendingFeedback = false;
export const CART_ADDED_RESULT_EVENT = "ac:cart-added-result";

export type CartAddedResult = {
  success: boolean;
  item?: { id: number | string; type: "product" | "service" };
};

export function publishCartAddedResult(success: boolean, item?: CartAddedResult["item"]): void {
  window.dispatchEvent(new CustomEvent<CartAddedResult>(CART_ADDED_RESULT_EVENT, { detail: { success, item } }));
}

/** Call before a user addition; background cart saves should not show success feedback. */
export function signalCartAddedFeedback(): void {
  pendingFeedback = true;
  try {
    sessionStorage.setItem(STORAGE_KEY, "1");
  } catch {
    /* private mode */
  }
}

/** Consume once when the server accepts a user addition. */
export function consumeCartAddedFeedbackSignal(): boolean {
  const pending = pendingFeedback;
  pendingFeedback = false;
  try {
    if (sessionStorage.getItem(STORAGE_KEY)) {
      sessionStorage.removeItem(STORAGE_KEY);
      return true;
    }
  } catch {
    /* ignore */
  }
  return pending;
}

/** Discard success feedback when the server rejects a cart update. */
export function cancelCartAddedFeedback(): void {
  pendingFeedback = false;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
